const ItemState = {
    items: { data: [] },
    item: {},
    categories: { data: [] },
};

export default ItemState;